export interface WhatsAppActivityCreateRequestModel {
  name: string;
}
